import React from 'react'

export const southDakotaSetupVars = {
  siteId: 'arizona',
  pathPrefix: '/az',
  menuHeader: "Discover Arizona's Solution for:",
  appUrl: 'https://az.headed2.com',
  logoImg: '/images/assets/arizona/horizontal/dark.svg',
  headerTitle: `The Arizona CareerExplorer is a system designed for Arizona`
}
